// Function 1: Apply layout from sessionStorage
function applySavedLayout() {
    const wrapper = document.querySelector('.wizzy-search-wrapper');
    const buttons = document.querySelectorAll('.m-collection-toolbar__column-switcher button');

    if (!wrapper) return;

    let layoutLevel = sessionStorage.getItem('wizzyLayout');

    // Default value
    if (!layoutLevel) {
        layoutLevel = '2';
        sessionStorage.setItem('wizzyLayout', layoutLevel);
    }

    // Apply attribute
    wrapper.setAttribute('wizzy-grid-view-level', layoutLevel);

    // Update active class
    buttons.forEach(btn => {
        btn.classList.remove('active');
        if (
            (layoutLevel === '2' && btn.dataset.layout === 'grid') ||
            (layoutLevel === '1' && btn.dataset.layout === 'list')
        ) {
            btn.classList.add('active');
        }
    });
}


// Function 2: Attach click events (prevent duplicate binding)
function initLayoutToggle() {
    const buttons = document.querySelectorAll('.m-collection-toolbar__column-switcher button');
    const wrapper = document.querySelector('.wizzy-search-wrapper');

    if (!buttons.length || !wrapper) return;

    buttons.forEach(btn => {
        // Prevent multiple event bindings
        if (btn.dataset.listenerAttached === 'true') return;

        btn.addEventListener('click', function () {
            let layoutLevel = this.dataset.layout === 'grid' ? '2' : '1';

            // Update DOM
            wrapper.setAttribute('wizzy-grid-view-level', layoutLevel);

            // Save to sessionStorage
            sessionStorage.setItem('wizzyLayout', layoutLevel);

            // Update active state
            buttons.forEach(b => b.classList.remove('active'));
            this.classList.add('active');
        });

        // Mark as attached
        btn.dataset.listenerAttached = 'true';
    });
}



window.onWizzyScriptLoaded = function () {

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      // window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
      //   {
      //       "dom": "wizzy-search-input",
      //       "type": "text"
      //   }
      // ]
      // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main");
      payload.filters.configs.layout = "v1";
      payload.search.configs.facets.leftFacets.mobileCollapsible = !0;

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      // window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
      //   {
      //       "dom": "wizzy-search-input",
      //       "type": "text"
      //   }
      // ]
      // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main");
      payload.filters.configs.layout = "v1";
      payload.search.configs.facets.leftFacets.mobileCollapsible = !0;

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED")

      payload.forEach(product => {
        if (product.attributes && Array.isArray(product.attributes)) {
            product.attributes.forEach(attr => {
              // Example: extract productHandle
              if (attr.id === "product_handle" && attr.values?.length) {
                  product.productHandle = attr.values[0].value[0];
              }

              if (attr.id === "product_badge_judgeme" && attr.values?.length) {
                const htmlString = attr.values[0].value[0];

                if (htmlString) {
                  // Extract using regex
                  const ratingMatch = htmlString.match(/data-average-rating=['"]([^'"]+)['"]/);
                  const reviewsMatch = htmlString.match(/data-number-of-reviews=['"]([^'"]+)['"]/);
                  const questionsMatch = htmlString.match(/data-number-of-questions=['"]([^'"]+)['"]/);

                  if (ratingMatch) {
                    product.averageRating = parseFloat(ratingMatch[1]);
                  }
                  if (reviewsMatch) {
                    product.totalReviews = parseInt(reviewsMatch[1], 10);
                  }
                  if (questionsMatch) {
                    product.totalQuestions = parseInt(questionsMatch[1], 10);
                    product.zeroQuestions = false;
                    if(product.totalQuestions === 0) {
                      product.zeroQuestions = true;
                    }
                  }
                }
              }
            });
          }

          if (typeof product.averageRating === "number") {
            let rating = product.averageRating;

            let fullStars = Math.floor(rating);
            let decimal = rating - fullStars;

            let stars = [];

            for (let i = 0; i < 5; i++) {
              let state = "jdgm--off";

              if (i < fullStars) {
                state = "jdgm--on";
              } else if (i === fullStars) {
                if (decimal >= 0.75) {
                  state = "jdgm--on";
                } else if (decimal > 0) {
                  state = "jdgm--half";
                }
              }

              stars.push({ class: state }); // 👈 IMPORTANT CHANGE
            }

            product.ratingStars = {
              value: rating,
              stars: stars
            };
          }

        });
      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
      // payload.minQueryLength = 1;
      return payload;
    }
  );

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");

      return data;
    })

     window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function (payload) {
        // console.log(payload,"BEFORE_AUTOCOMPLETE_EXECUTED")
        return payload;
      }
    );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_SEARCH_EXECUTED")

      const closeBtn = document.querySelector('.m-search-modal__header .m-search-modal__close-button');
      if (closeBtn) {
        closeBtn.click();
      }

      return payload;
    }
  );

     window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log(data," <= VIEW_RENDERED");

      initLayoutToggle();
      applySavedLayout();
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      // console.log(payload,"PRODUCTS_CACHED_RESULTS_RENDERED");

      initLayoutToggle();
    
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log(payload,"BEFORE_RENDER_RESULTS");
    
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      return payload;
    }
  );
};

/////////////////////////////////////////////////////////////////////////

// function updateAutocompletePosition() {
//   // Run only on desktop
//   if (window.innerWidth < 1025) return;

//   const searchInput = document.querySelector(
//     '.m-header__search .wizzy-search-input'
//   );

//   const autocompleteWrapper = document.querySelector(
//     '.wizzy-autocomplete-wrapper'
//   );

//   // Exit if required elements are not present
//   if (!searchInput || !autocompleteWrapper) return;

//   const rect = searchInput.getBoundingClientRect();

//   autocompleteWrapper.style.position = 'fixed';
//   autocompleteWrapper.style.top = `${rect.top + 40}px`;
//   autocompleteWrapper.style.left = `${rect.left + 10}px`;
// }

/////////////////////////////////////////////

function updateAutocompletePosition() {
  // Desktop only
  if (window.innerWidth < 1025) return;

  const searchInput = document.querySelector(
    '.m-header__search .wizzy-search-input'
  );

  const autocompleteWrapper = document.querySelector(
    '.wizzy-body-end-wrapper .wizzy-autocomplete-wrapper'
  );

  // Exit if elements are missing
  if (!searchInput || !autocompleteWrapper) return;

  const rect = searchInput.getBoundingClientRect();

  autocompleteWrapper.style.position = 'fixed';
  autocompleteWrapper.style.top = `${rect.top + 45}px`;
  autocompleteWrapper.style.left = `${rect.left + 10}px`;
}

function initSearchInputObserver() {
  const searchInput = document.querySelector(
    '.m-header__search .wizzy-search-input'
  );

  const wrapperParent = document.querySelector(
    '.wizzy-body-end-wrapper'
  );

  if (!searchInput || !wrapperParent) return;

  // Prevent duplicate init
  if (wrapperParent._autocompleteObserverInitialized) return;

  wrapperParent._autocompleteObserverInitialized = true;

  // Observe autocomplete wrapper added/updated
  const observer = new MutationObserver(() => {
    const autocompleteWrapper = wrapperParent.querySelector(
      '.wizzy-autocomplete-wrapper'
    );

    if (autocompleteWrapper) {
      updateAutocompletePosition();
    }
  });

  observer.observe(wrapperParent, {
    childList: true,
    subtree: true,
    attributes: true
  });

  wrapperParent._autocompleteObserver = observer;

  // Input typing changes
  searchInput.addEventListener('input', updateAutocompletePosition);

  // Initial check
  updateAutocompletePosition();
}

// Init
initSearchInputObserver();